import { useQuery } from "@apollo/client";
import { Plus } from "lucide-react";
import { useCallback, useState } from "react";
import { businessUnitUsersQuery } from "./api/queries";
import { UserInviteForm } from "./UserInviteForm";
import { UserTable } from "./UsersTable";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { useActiveBusinessUnit } from "@/hooks/use-active-business-unit";
import { removeNothings } from "@/lib/utils/arrays";

export function UserSettingsPage() {
  const { activeBusinessUnit, activeBusinessUnitIdInt } = useActiveBusinessUnit();
  const [inviteFormOpen, setInviteFormOpen] = useState(false);

  const { data, loading, error, refetch } = useQuery(businessUnitUsersQuery, {
    variables: { businessUnitId: activeBusinessUnitIdInt || -1 },
  });

  const users = removeNothings(data?.businessUnitUsers || []);

  const handleUserUpdated = useCallback(() => {
    void refetch();
  }, [refetch]);

  const handleInviteSuccess = useCallback(() => {
    void refetch();
  }, [refetch]);

  return (
    <>
      <PageHeader>
        <PageHeader.Content>
          <PageHeader.Title>Users</PageHeader.Title>
          <PageHeader.Description>
            {activeBusinessUnit?.name
              ? `Manage users in ${activeBusinessUnit.name}`
              : "Manage users in your business unit"}
          </PageHeader.Description>
        </PageHeader.Content>
        <PageHeader.Actions>
          <Button onClick={() => setInviteFormOpen(true)} disabled={loading || !!error}>
            <Plus className="mr-2 h-4 w-4" />
            Invite User
          </Button>
        </PageHeader.Actions>
      </PageHeader>
      <div className="flex h-full flex-col pt-6">
        <div className="flex-1 pb-8">
          <UserTable users={users} loading={loading} error={error} onUserUpdated={handleUserUpdated} />
        </div>
        <UserInviteForm open={inviteFormOpen} onOpenChange={setInviteFormOpen} onSuccess={handleInviteSuccess} />
      </div>
    </>
  );
}
